import React from 'react';
import Navbar from '../../Navbar/Navbar';
import ProjectPageInfo from '../ProjectPageInfo/ProjectPageInfo';

const ProjectPageManagement = () => {
    return (
        <div>
            <Navbar />
            <ProjectPageInfo />
        </div>
    );
};

export default ProjectPageManagement;